import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import SelectPeriod from '../../../Components/shared/SelectPeriod';
import SelectUser from '../../../Components/shared/SelectUser';
import { PeriodeDashboardListFtrCra } from '../../../data/Interfaces';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';

function StatutCras({allCras,filtreClient,width,height,role}){

    StatutCras.propTypes = {
        allCras: PropTypes.any,
        filtreClient: PropTypes.any,
        width: PropTypes.any,
        height:PropTypes.any,
        role:PropTypes.any,
    };

    const [selectedPeriodCra, setSelectedPeriodCra] = useState('thisMonth');
    const [selectedClientvalueCra,setSelectedClientvalueCra] = useState('all');// Default selected client
    const [customDateRangeCra, setCustomDateRangeCra] = useState({});
    const { i18n } = useTranslation();
    const colors = role === 'client' ?
        ['#EFAF41', '#EC5B56', '#214DCE', '#5CC889'] :
        ['#EFAF41', '#EC5B56', '#214DCE', '#5CC889', '#ffa090'];

    const craStatutsLabels = role === 'client' ?
        [i18n.t('En attente validation-Client'),i18n.t('Rejeté'),i18n.t('En attente validation-Expert'),i18n.t('Validé')] :
        [i18n.t('En attente validation-Client'),i18n.t('Rejeté'),i18n.t('En attente validation-Expert'),i18n.t('Validé'),i18n.t('Cra Nul')];

    const [chartDataStatusCra, setChartDataStatusCra] = useState(
        {
            series: [],
            chart: {
                type: 'pie',
                height: 350,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            options:{
                labels:[],
                colors: colors,
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                plotOptions: {
                    pie: {
                        startAngle: 0,
                        endAngle: 360,
                    }
                },
                stroke: {
                    show: true,
                    width: 0, // Set the stroke width to 0 to eliminate the gap between slices
                },
            },
        });
    const getStatusCraCounts = (data) => {
        const defaultCounts = {
            VE: 0,
            NV: 0,
            pending: 0,
            VC: 0,
            NULL: 0,
            total: data.length
        };
        const clientCounts = {
            VE: 0,
            NV: 0,
            pending: 0,
            VC: 0,
            total: data.length
        };
        // const clientCounts = {
        //     ...defaultCounts,
        //     NULL: undefined
        // };

        const counts = role === 'client' ? clientCounts : defaultCounts;

        data.forEach(item => {
            const { statutCra } = item;
            counts[statutCra]++;
        });
        return counts;
    };
    useEffect(()=>{
        if(Array.isArray(allCras) ){
            var filteredData = allCras;
            if(filtreClient)
                if (selectedClientvalueCra != 'all') {
                    filteredData = filteredData.filter(
                        (item) => item.companyDataId == selectedClientvalueCra
                    );
                }

            filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriodCra,customDateRangeCra);

            let countsCra=getStatusCraCounts(filteredData);

            setChartDataStatusCra((prevState) => {
                return {
                    ...prevState,

                    series: Object.values(countsCra).slice(0, -1),
                    options:{
                        ...prevState.options,
                        labels:craStatutsLabels,
                        plotOptions: {
                            ...prevState.options.plotOptions,
                            pie: {
                                ...prevState.options.plotOptions.pie,
                                dataLabels: {
                                    ...prevState.options.plotOptions.pie.dataLabels,
                                    offset: -15, // Adjust the offset to vertically center the labels
                                    formatter: function (val, opts) {
                                        return opts.w.config.series[opts.seriesIndex];
                                    },
                                },
                            },
                        },

                    }
                };
            });
        }
    },[allCras,customDateRangeCra,selectedClientvalueCra]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Statuts CRA')}</h1>
                <div className='filtre1'>
                    <div style={{width:'40%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodCra}
                            setSelectedPeriod={setSelectedPeriodCra}
                            setCustomDateRange={setCustomDateRangeCra}
                            listeVal={PeriodeDashboardListFtrCra}

                        />
                    </div>
                    {filtreClient &&
                        <div style={{width:'40%'}}>
                            <SelectUser
                                selectedClientvalue={selectedClientvalueCra}
                                setSelectedClientvalue={setSelectedClientvalueCra}
                            />
                        </div>
                    }

                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataStatusCra.options}
                        series={chartDataStatusCra.series}
                        type="pie"
                        width={'100%'}
                        height={'85%'}
                    />
                </div>
            </div>
        </>
    );
}
export default StatutCras;
